export const DOCUMENT_TYPE_COLLECTION_FRONTPAGE = 'collection-frontpage';
